import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkImage, UitkFigure } from "uitk-react-images";
import { UitkScrim } from "uitk-react-scrim";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkText } from "uitk-react-text";
import { UitkCard, UitkCardLink } from "uitk-react-cards";

import ProductIcon from "./ProductIcon";
import ProductDateSupportText from "./ProductDateSupportText";
import ProductPriceSupportText from "./ProductPriceSupportText";
import { TrackedLink } from "components/utility/analytics/TrackedLink";

import { CityCardDestination } from "typings/microserviceModels/top-cities-flex-module";

const FullBleedImageCityCard = (props: {
  city: CityCardDestination;
  index: number;
  pageType: string;
  hideProductIcon: boolean;
}) => {
  const { city, index, pageType, hideProductIcon } = props;
  const { name: cityName, link, deal } = city;
  const mainImage = city.images[0];
  const { formatText } = useLocalization();

  return (
    <UitkCard>
      <UitkFigure ratio={UitkFigure.AspectRatio.R16_9}>
        <UitkImage src={mainImage.url} alt={mainImage.alt} placeholderImage lazyLoading="lazy" />
        {!hideProductIcon && <ProductIcon index={index} cardType="full-bleed-image" />}
        <UitkScrim>
          <UitkLayoutFlex justifyContent="space-between" alignItems="end">
            <UitkLayoutFlex direction="column">
              <UitkText size={500} weight="bold">
                {cityName}
              </UitkText>
              <ProductDateSupportText deal={deal} />
            </UitkLayoutFlex>
            {deal && (
              <UitkLayoutFlex direction="column">
                <UitkText size={300} align="right">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: formatText("topCities.productPrice", deal.priceFormatted),
                    }}
                  />
                </UitkText>
                <ProductPriceSupportText />
              </UitkLayoutFlex>
            )}
          </UitkLayoutFlex>
        </UitkScrim>
      </UitkFigure>

      <UitkCardLink>
        <TrackedLink
          moduleName="topCities"
          rfrr={pageType}
          href={link}
          data-testid={`top-cities-full-bleed-image-${index}`}
        >
          {cityName}
        </TrackedLink>
      </UitkCardLink>
    </UitkCard>
  );
};

export default FullBleedImageCityCard;
